(() => {
  if (window.__ga4ProductCardClickInit) return;
  window.__ga4ProductCardClickInit = true;

  const closestSectionRoot = (el) =>
    el?.closest?.('[id^="shopify-section-"]') || null;

  const extractHeading = (sectionRoot) => {
    if (!sectionRoot) return '';

    const headingEl =
      sectionRoot.querySelector('.title-wrapper .heading split-words') ||
      sectionRoot.querySelector('.title-wrapper split-words') ||
      sectionRoot.querySelector('.title-wrapper .heading');

    return (headingEl?.textContent || '').trim();
  };

  const extractSubheading = (sectionRoot) => {
    if (!sectionRoot) return '';

    // Featured-collections tabs: 当前激活 tab 按钮通常带 disabled
    const activeTab =
      sectionRoot.querySelector('.tab-list [role="tab"][disabled] .btn-text') ||
      sectionRoot.querySelector('.tab-list [role="tab"][aria-selected="true"] .btn-text') ||
      sectionRoot.querySelector('.tab-list [role="tab"][aria-selected="true"]');
    if (activeTab) return (activeTab.textContent || '').trim();

    // 普通 section subheading（如果存在）
    const subheadingEl = sectionRoot.querySelector('.title-wrapper > .grid p.heading');
    return (subheadingEl?.textContent || '').trim();
  };

  const extractTitleAndLink = (card) => {
    const titleLink =
      card.querySelector('a.product-card__title') ||
      card.querySelector('a[href]');

    const title = (card.dataset.ga4Title || titleLink?.textContent || '').trim();
    const link = (card.dataset.ga4Link || titleLink?.getAttribute('href') || '').trim();
    return { title, link };
  };

  document.addEventListener(
    'click',
    (e) => {
      const target = e.target;
      if (!(target instanceof Element)) return;

      const card = target.closest('[data-ga4-product-card="1"]');
      if (!card) return;

      const sectionRoot = closestSectionRoot(card);
      const heading = (card.dataset.ga4Heading || extractHeading(sectionRoot) || '').trim();
      const subheading = (card.dataset.ga4Subheading || extractSubheading(sectionRoot) || '').trim();
      const { title, link } = extractTitleAndLink(card);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'header-cta',
        event_parameters: {
          current_page: window.location.href,
          heading: heading || '',
          subheading: subheading || '',
          title: title || '',
          link: link || ''
        }
      });
    },
    { capture: true }
  );
})();

